import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/gifs/globalLoading2.gif';
const _hoisted_1 = {
  class: "w-full py-4"
};
const _hoisted_2 = {
  class: "relative bg-wg-50 w-full h-56 flex flex-col items-center justify-center rounded-2xl text-main-100 overflow-hidden"
};
const _hoisted_3 = {
  class: "absolute bottom-5 text-xs animate-fade"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$state.flowLauncherController?.ui?.loadingMessage), 1)])]);
}